<app-header-three></app-header-three>
<!-- Contact Start -->
<div class="contact-wrapper">

    <div class="">
     <div  id="map" style="height:500px;width: 100%; display:none;"></div>
		<div class="section-title-wrap" style="padding: 14px;">
            <h2 class="title">Send us a Message </h2>
            <div class="alert alert-primary" role="alert" *ngIf="contactUsFormMessage!=''">
			 {{contactUsFormMessage}}
			</div>
		</div>

		<form style="padding: 14px;" class="form" [formGroup]="contactUsForm"  (ngSubmit)="contactUsFormAdd()" id="registrationForm">
            <div class="row">
              <div class="form-group col-lg-6">
				<span [ngClass]="{ 'has-error': isSubmitted && formControls.fullname.errors }">
				<input type="text" placeholder="First Name" class="form-control" formControlName="fullname">
				</span>
			  </div>
              <div class="form-group col-lg-6">
				<span [ngClass]="{ 'has-error': isSubmitted && formControls.lastname.errors }">
				<input type="text" placeholder="Last Name" class="form-control" formControlName="lastname">
				</span>
			  </div>
              <div class="form-group col-lg-12">
				<span [ngClass]="{ 'has-error': isSubmitted && formControls.email.errors }">

                <input type="email" placeholder="Email Address" class="form-control" formControlName="email">
				</span>
			  </div>
              <div class="form-group col-lg-12">
				<span [ngClass]="{ 'has-error': isSubmitted && formControls.subject.errors }">
                <input type="text" placeholder="Subject" class="form-control" formControlName="subject">
				</span>
			  </div>
              <div class="form-group col-lg-12">
				<span [ngClass]="{ 'has-error': isSubmitted && formControls.message.errors }">
				<textarea name="message" class="form-control" placeholder="Type your message" rows="8" formControlName="message"></textarea>
				</span>
			  </div>
            </div>
			<div  *ngIf="contactSpin" class="category-box-icon d-flex">
				<i class="fas fa-spinner spinner"></i>
			</div>
			<button *ngIf="!contactSpin" class="btn-custom shadow-none" type="submit">
			<i class="glyphicon glyphicon-ok-sign"></i> Send Message</button>       
		</form>

    </div>

    <div class="">
        <div class="section pt-0">
        <div class="container">
		<div class="row " >
		  <div class="col-xl-6" *ngFor="let  francais of  francaisList">
			<div class="ct-info-box">
			  <i class="flaticon-location"></i>
			  <h5>{{francais.name}}</h5>
			  <span>{{francais.address}}</span>
			  <span>Opening Time {{francais.open_time}}</span>
			  <span>Closing Time  {{francais.close_time}} </span>
			
			</div>
		  </div>
		</div>
          

        </div>
      </div>
    </div>

  </div>
  <!-- Contact End -->
<app-footer></app-footer>